import { Grid } from "@mui/material";
import _, { debounce } from "lodash";
import React, {
  useCallback,
  useContext,
  useEffect,
  useRef,
  useState,
} from "react";
import { useDispatch, useSelector } from "react-redux";
import Checkbox from "../../../../framework/Checkbox";
import ChipInputSelect from "../../../../framework/ChipInputSelect";
import GlobalContext from "../../../../framework/GlobalContext";
import NumberInput from "../../../../framework/NumberInput";
import SelectInput from "../../../../framework/SelectInput";
import TextInput from "../../../../framework/TextInput";
import TreeSelect from "../../../../framework/tree-select";
import { searchManufacturerForProduct } from "../../../../services/manufacturer-services";
import {
  getMedicineDetails,
  searchCompounds,
  searchGlobalMedicine,
  searchItemType,
} from "../../../../services/medicine-services";
// import {
//   gstValues,
//   medicineScheduleTypes,
//   storageOptions,
//   therapeuticTypes,
// } from "../../../../utils/constants";
import { searchCategories } from "../../../../services/category-services";
import { searchHsn } from "../../../../services/hsn-services";
import { searchBrands } from "../../../../services/medicine-services";
import {
  gstValues,
  medicineScheduleTypes,
  storageOptions,
  therapeuticTypes,
} from "../../../../utils/constant";
import {
  checkErrorStateExists,
  formStateHandler,
} from "../../../../utils/utils";

const GeneralTab = (props) => {
  const {
    isProductSearchable = true,
    removeErrorStateOnChange = () => {},
    resetForm = () => {},
    validateForm = () => {},
    isAddIngredients,
    getIngredients = () => {},
    categoryRef,
    showAddProduct,
    editProductId = null,
  } = props;

  const [isGenericDosageReadOnly, setIsGenericDosageReadOnly] = useState(false);
  // const [medicineItemTypes, setMedicineItemTypes] = useState([]);
  const [itemTypeOptions, setItemTypeOptions] = useState([]);
  // const { itemTypeOptions } = useSelector((state) => state.commonReducer);

  const [category, setCategory] = useState(null);
  const [isLoose, setIsLoose] = useState(false);
  const [isChronic, setIsChronic] = useState(false);
  const [isTb, setIsTb] = useState(false);
  const [categoryOptions, setCategoryOptions] = useState([]);
  const [hsnOptions, setHsnOptions] = useState([]);
  const [brandOptions, setBrandOptions] = useState([]);

  const productNameRef = useRef();
  const hsnCodeRef = useRef(null);
  const brandRef = useRef();

  const dispatch = useDispatch();

  const {
    setCurrentComponent,
    isAddRecipe = false,
    findCategory,
  } = useContext(GlobalContext);

  // const { editProductData } = useContext(CommonContext);

  const [medicineOptions, setMedicineOptions] = useState([]);
  const [manufacturerOptions, setManufacturerOptions] = useState([]);
  const [compoundOptions, setCompoundOptions] = useState([]);
  // const [manufacturerGroupName, setManufacturerGroupName] = useState("");

  const { formState, errorState } = useSelector(
    (state) => state.commonReducer.common.addProduct
  );

  const dispatchFormState = useCallback(
    (newState) => {
      dispatch({
        type: "set_add_product_form_state",
        payload: newState,
      });
    },
    [dispatch]
  );

  // eslint-disable-next-line
  const debounceDispatchFormState = useCallback(
    debounce(dispatchFormState, 1),
    []
  );

  const handleFormChange = useCallback(
    (fieldName, fieldValue, isSelect = false, options) => {
      let newFormState = formStateHandler(
        formState,
        fieldName,
        fieldValue,
        isSelect,
        options
      );
      debounceDispatchFormState(newFormState);
    },
    [debounceDispatchFormState, formState]
  );

  const searchMedicine = useCallback((searchTerm) => {
    searchGlobalMedicine(`search=${searchTerm.replace(" ", "")}`).then(
      (response) => {
        setMedicineOptions(
          response?.result.map((medicineData) => {
            return {
              id: medicineData.medicineId,
              label: medicineData.medicineNameDetailed,
              medicineName: medicineData.medicineName,
            };
          })
        );
      }
    );
  }, []);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const debounceSearchMedicine = useCallback(
    _.debounce(searchMedicine, 300, { leading: true }),
    []
  );

  const manufacturerChangedHandler = useCallback(
    async (event, value) => {
      removeErrorStateOnChange("add_product_manufacturer");
      if (!event) return;
      if (!event.target.value) return;
      let _options = [];
      if (value?.length > 2) {
        await searchManufacturerForProduct(
          `manufacturerName=${value.trim()}`
        ).then((response) => {
          let result = response?.result?.rows || [];
          result = result.map((manufacturerData) => {
            return {
              id: manufacturerData.manufacturerId,
              label: manufacturerData.manufacturerName,
              manufacturerGroupName:
                manufacturerData?.manufacturerGroupName || "",
            };
          });
          _options = result;
        });
        setManufacturerOptions(_options);
      }
    },
    [removeErrorStateOnChange]
  );

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const debounceDispatchManufactureChange = useCallback(
    _.debounce(manufacturerChangedHandler, 300, { leading: true }),
    []
  );
  const compoundInputChangeHandler = useCallback((event, value) => {
    if (value?.length > 2) {
      searchCompounds(`search=${value.trim()}`).then((response) => {
        setCompoundOptions(response?.result?.rows);
      });
    }
  }, []);

  const substituteChangeHandler = useCallback(
    (e, substitute) => {
      let paylaod = { ...formState };
      setIsGenericDosageReadOnly(true);
      paylaod = {
        ...paylaod,
        substitute: substitute,
      };
      if (!substitute) {
        handleFormChange("substitute", {});
        setIsGenericDosageReadOnly(false);
        return;
      }
      getMedicineDetails(`medicineId=${substitute.id}`).then((res) => {
        if (res?.result?.generic) {
          paylaod = {
            ...paylaod,
            scheduleType:
              medicineScheduleTypes.find(
                (scheduleType) =>
                  scheduleType.label === res?.result?.generic?.genericType
              ) || null,
          };
          removeErrorStateOnChange("add_product_schedule_type");
          paylaod = {
            ...paylaod,
            genericDosage: res?.result?.generic?.genericDosage?.length
              ? [res?.result?.generic.genericDosage]
              : [],
          };
        }
        dispatchFormState(paylaod);
      });
    },
    [removeErrorStateOnChange, dispatchFormState, formState, handleFormChange]
  );

  const dispatchCategoryPath = useCallback(() => {
    dispatch({
      type: "update_category_path",
      payload: categoryRef.current?.getPath(),
    });
  }, [dispatch, categoryRef]);

  const dispatchSelectedProductFormState = useCallback(
    (data) => {
      let _category = findCategory(categoryOptions, data.categoryId);
      _category = categoryRef.current?.getValue(_category);
      const payload = {
        productName: data?.medicineName,
        productId: data?.medicineId,
        productBrand: data?.medicineNameBase,
        itemType: isAddRecipe
          ? { id: "RECIPE", label: "Recipe" }
          : { id: data?.itemtype, label: data?.itemtype },
        medicinePackaging: data?.medicinePackaging,
        therapeutic: data?.therapeutic
          ? { id: data?.therapeutic, label: data?.therapeutic }
          : null,
        subTherapeutic: data?.subtherapeutic,
        manufacturer: {
          label: data?.manufacturerName || "",
          id: data?.manufacturerId || "",
        },
        manufacturerGroupName: data?.manufacturer?.manufacturerGroupName || "",
        gst: gstValues.find((g) => g.id === data?.medicineGstPer),
        minStock: data?.minStock || null,
        maxStock: data?.maxStock || null,
        minDays: data?.minDays || null,
        maxDays: data?.maxDays || null,
        hsnCode: data?.hsnCode,
        rack: data?.rack || "",
        rack1: data?.rack1 || "",
        description: data?.description || "",
        remarks: data?.remarks,
        isTb: data?.generic?.istb || false,
        disableAutoBarcodePrinting: data?.disableAutoBarcodePrinting || false,
        isLoose: data?.isLoose || false,
        divisor: isAddRecipe ? 1 : data?.divisor,
        scheduleType: !isAddRecipe
          ? data?.scheduledId
            ? medicineScheduleTypes.find((s) => s.id === data?.scheduledId)
            : null
          : medicineScheduleTypes[0],
        genericDosage: data?.genericDosage?.length
          ? [data.genericDosage]
          : data?.generic?.genericDosage?.length
          ? [data?.generic?.genericDosage]
          : [],
        divisorUnit: data?.divisorUnit,
        category: _category,
        barcode: data?.barcode,
        maxDiscount: data?.maxDiscount,
        discPer: data?.discPer,
        tcsPer: data?.tcsPer,
        gccess: data?.gccess,
        vat: data?.vat,
        isBanned: data?.isBanned,
        isDiscontinued: data?.isDiscontinued,
        isUndeliverable: data?.isUndeliverable,
        isActive: data?.isActive,
        skipFromApo: data?.skipFromApo,
        skipFromShortBook: data?.skipFromShortBook,
        blockExpiryPrint: data?.blockExpiryPrint,
        allowWeb: data?.allowWeb,
        serviceItem: data?.serviceItem,
        storage: data?.storage
          ? storageOptions.find((s) => s.label === data?.storage)
          : null,
        isChronic: data?.isChronic,
        outerQtyPack: data?.outerQtyPack,
        marketer: data?.marketerId
          ? { id: data?.marketerId, label: data?.marketerName }
          : null,
        allowDiscount: data?.allowDiscount,
        medicineShortCode: data?.medicineShortCode,
        scheme: data?.passiveScheme,
        boxMrp: data?.boxMrp,
        boxPtr: data?.boxPtr,
        passiveMrp: data?.passiveMrp,
        passiveCp: data?.passiveCp,
        sellingPrice: data?.sellingPrice,
        markup: data?.markup,
        currentStock: data?.currQuantity,
        isReturnable: data?.isReturnable,
        rateItemwise: data?.rateItemwise,
        computeMinMax: data?.computeMinMax,
        autoOrderDays: data?.autoOrderDays || null,
        b2BOffset: data?.b2BOffset ?? null,
        b2bSellingPrice: data?.b2bSellingPrice ?? null,
        b2bForceSellingPrice: data?.b2bForceSellingPrice || false,
      };
      dispatch({
        type: "set_add_product_form_state",
        payload: payload,
      });
      dispatchCategoryPath();
    },
    [
      dispatch,
      categoryOptions,
      findCategory,
      categoryRef,
      dispatchCategoryPath,
      isAddRecipe,
    ]
  );

  const updateSelectedProduct = useCallback(
    (productId) => {
      if (!productId) return;
      getMedicineDetails(`medicineId=${productId}`).then((res) => {
        if (!res) return;
        if (res?.result.recipeItem?.length === 0) {
          res?.resultetIngredients();
        }
        if (res?.result.recipeItem?.length > 0) {
          getIngredients(res?.result.recipeItem);
        }
        dispatchSelectedProductFormState(res?.result);
        return;
      });
    },
    [dispatchSelectedProductFormState, getIngredients]
  );

  useEffect(() => {
    if (!editProductId) return;
    updateSelectedProduct(editProductId);
  }, [updateSelectedProduct, editProductId]);

  useEffect(() => {
    if (!formState) return;
    setCategory(formState?.category);
    setIsLoose(formState?.isLoose);
    setIsChronic(formState?.isChronic);
    setIsTb(formState?.isTb);
  }, [formState]);

  useEffect(() => {
    searchCategories().then((response) => {
      if (response) {
        let updatedResp = [];
        response?.result?.rows?.forEach((cat) => {
          updatedResp.push({
            ...cat,
            id: cat.categoryId,
            name: cat.categoryName,
          });
        });
        setCategoryOptions(updatedResp);
      }
    });
  }, []);

  useEffect(() => {
    searchItemType().then((resp) => {
      if (resp.result) {
        setItemTypeOptions(
          resp.result?.rows?.map((it) => {
            return {
              id: it,
              label: it,
            };
          })
        );
      }
    });
  }, []);

  useEffect(() => {
    if (isAddRecipe && !productNameRef.current?.value) {
      const paylaod = {
        ...formState,
        itemType: { id: "RECIPE", label: "Recipe" },
        scheduleType: medicineScheduleTypes[0],
        divisor: 1,
      };
      dispatchFormState(paylaod);
    }
  }, [isAddRecipe, dispatchFormState, formState]);

  useEffect(() => {
    if (!showAddProduct) {
      setCurrentComponent("grid_reports");
    }
  }, [setCurrentComponent, showAddProduct]);

  useEffect(() => {
    return () => {
      setCategory(null);
      setIsLoose(false);
    };
  }, []);

  return (
    <>
      {!isAddIngredients && (
        <Grid
          container
          spacing={2}
          columns={6}
          sx={{
            margin: "5px 0px 5px -10px",
            width: "100%",
          }}
        >
          <Grid item xs={1.2}>
            {isProductSearchable ? (
              <SelectInput
                ref={productNameRef}
                label="Product Name"
                id="add_product_name"
                onFocus={() => {
                  setCurrentComponent("add_product_name");
                }}
                onChange={(e, newValue) => {
                  removeErrorStateOnChange("add_product_name");
                  updateSelectedProduct(newValue.id);
                }}
                getOptionLabel={(option) => option.label || option}
                isOptionEqualToValue={(option, value) => {
                  return option?.label === value.label || value === "";
                }}
                value={formState?.productName}
                freeSolo={true}
                renderOption={(props, option) => {
                  return (
                    <li {...props} key={option.id}>
                      {option.label}
                    </li>
                  );
                }}
                maxInputLength={1000}
                onInputChange={(e, value) => {
                  removeErrorStateOnChange("add_product_name");
                  if (value?.length > 2) {
                    debounceSearchMedicine(value);
                  }
                  if (value?.length === 0 && !editProductId) {
                    resetForm();
                  } else {
                    handleFormChange("productName", e.target.value);
                  }
                }}
                options={medicineOptions}
                onBlur={(e) => {
                  validateForm("add_product_name", formState);
                }}
                markers={JSON.stringify({
                  down: "add_product_short_code",
                  left: "add_product_description",
                  right: "add_product_category",
                  up: "add_product_name",
                })}
                error={checkErrorStateExists("add_product_name", errorState)}
                required={true}
                autoFocus
              />
            ) : (
              <TextInput
                label="Product Name"
                id="add_product_name"
                ref={productNameRef}
                value={formState?.productName}
                onFocus={() => {
                  setCurrentComponent("add_product_name");
                }}
                onBlur={(e) => {
                  validateForm("add_product_name", formState);
                }}
                onChange={(e, value) => {
                  handleFormChange("productName", e.target.value);
                  removeErrorStateOnChange("add_product_name");
                }}
                maxInputLength={1000}
                inputProps={{
                  "data-markers": JSON.stringify({
                    down: "add_product_short_code",
                    left: "add_product_description",
                    right: "add_product_category",
                    up: "add_product_name",
                  }),
                }}
                error={checkErrorStateExists("add_product_name", errorState)}
                required
                autoFocus
              />
            )}
          </Grid>
          <Grid item xs={1.2}>
            <TreeSelect
              id="add_product_category"
              onFocus={() => {
                setCurrentComponent("add_product_category");
              }}
              allowSelectingBranch={false}
              allowMultiple={false}
              showPath={false}
              ref={categoryRef}
              value={category}
              onChange={(e, value) => {
                removeErrorStateOnChange("add_product_category");
                handleFormChange("category", value);
              }}
              onBlur={(e) => {
                validateForm("add_product_category", formState);
                dispatchCategoryPath();
              }}
              options={categoryOptions}
              label="Category"
              error={checkErrorStateExists("add_product_category", errorState)}
              required
              inputProps={{
                "data-markers": JSON.stringify({
                  up: "add_product_category",
                  down: "add_product_brand",
                  left: "add_product_name",
                  right: "add_product_manufacturer",
                }),
              }}
            />
          </Grid>
          <Grid item xs={1.2}>
            <SelectInput
              id="add_product_manufacturer"
              value={formState?.manufacturer}
              name="manufacturerName"
              label="Manufacturer"
              onFocus={() => setCurrentComponent("add_product_manufacturer")}
              onBlur={(e) => {
                validateForm("add_product_manufacturer", formState);
                handleFormChange(
                  "manufacturerGroupName",
                  formState?.manufacturer?.manufacturerGroupName || null
                );
              }}
              onChange={(event, option) => {
                removeErrorStateOnChange("add_product_manufacturer");
                handleFormChange("manufacturer", option || null);
              }}
              options={manufacturerOptions}
              onInputChange={(e, value) => {
                if (!value) return handleFormChange("manufacturer", null);
                removeErrorStateOnChange("add_product_manufacturer");
                if (value?.length > 2) {
                  debounceDispatchManufactureChange(e, value);
                }
              }}
              getOptionLabel={(option) => option.label}
              isOptionEqualToValue={(option, value) =>
                value.id === "custom" ? value : option.label === value.label
              }
              maxInputLength={200}
              markers={JSON.stringify({
                up: "add_product_manufacturer",
                down: "add_product_type",
                left: "add_product_category",
                right: "add_product_marketer",
              })}
              error={checkErrorStateExists(
                "add_product_manufacturer",
                errorState
              )}
              required
              noOptionsText="Search manufacturer"
            />
          </Grid>
          <Grid item xs={1.2}>
            <TextInput
              id="add_product_manufacturer_group_name"
              name="manufacturerGroupName"
              value={formState?.manufacturerGroupName || ""}
              label="Manufacturer Group"
              onFocus={() =>
                setCurrentComponent("add_product_manufacturer_group_name")
              }
              onChange={(e) => {
                handleFormChange("manufacturerGroupName", e.target.value);
              }}
              inputProps={{
                "data-markers": JSON.stringify({
                  up: "add_product_manufacturer_group_name",
                  down: "add_product_packaging",
                  left: "add_product_manufacturer",
                  right: "add_product_marketer",
                }),
              }}
              disabled={true}
            />
          </Grid>
          <Grid item xs={1.2}>
            <SelectInput
              id="add_product_marketer"
              label="Marketer"
              name="marketer"
              value={formState?.marketer}
              onFocus={() => {
                setCurrentComponent("add_product_marketer");
              }}
              onChange={(event, option) => {
                handleFormChange("marketer", option);
              }}
              options={manufacturerOptions}
              onInputChange={(e, value) => {
                if (!value) return handleFormChange("marketer", null);
                if (value?.length > 2) {
                  debounceDispatchManufactureChange(e, value);
                }
              }}
              getOptionLabel={(option) => option.label}
              isOptionEqualToValue={(option, value) =>
                value.id === "custom" ? value : option.label === value.label
              }
              maxInputLength={200}
              markers={JSON.stringify({
                up: "add_product_marketer",
                down: "add_product_qty_per_unit",
                left: "add_product_manufacturer",
                right: "add_product_short_code",
              })}
              disableClearable={false}
              noOptionsText="Search marketer"
            />
          </Grid>
          <Grid item xs={1.2}>
            <TextInput
              id="add_product_short_code"
              name="medicineShortCode"
              value={formState?.medicineShortCode}
              label="Short Code"
              onFocus={() => setCurrentComponent("add_product_short_code")}
              onChange={(e) => {
                handleFormChange("medicineShortCode", e.target.value);
              }}
              maxInputLength={1000}
              inputProps={{
                "data-markers": JSON.stringify({
                  up: "add_product_name",
                  down: "add_product_outer_qty",
                  left: "add_product_marketer",
                  right: "add_product_brand",
                }),
              }}
            />
          </Grid>
          <Grid item xs={1.2}>
            <SelectInput
              id="add_product_brand"
              name="productBrand"
              value={formState?.productBrand || ""}
              label="Brand"
              inputRef={brandRef}
              options={brandOptions}
              onChange={(event, option) => {
                removeErrorStateOnChange("add_product_brand");
                handleFormChange("productBrand", option);
              }}
              getOptionLabel={(option) => option}
              freeSolo
              onFocus={() => setCurrentComponent("add_product_brand")}
              onBlur={() => validateForm("add_product_brand", formState)}
              onInputChange={(e, value) => {
                if (!value) return handleFormChange("productBrand", null);
                const newValue = e.target.value;
                removeErrorStateOnChange("add_product_brand");
                if (newValue?.length >= 3) {
                  searchBrands(`brandName=${newValue.trim()}`).then((resp) => {
                    const updatedResp = resp.result.rows;
                    setBrandOptions(updatedResp);
                  });
                } else {
                  setBrandOptions([]);
                }
                handleFormChange("productBrand", newValue);
              }}
              markers={JSON.stringify({
                right: "add_product_type",
                up: "add_product_category",
                down: "add_product_gst",
                left: "add_product_short_code",
              })}
            />
          </Grid>
          <Grid item xs={1.2}>
            <SelectInput
              id="add_product_type"
              name="itemtype"
              label="Pack Type(Strip, Bottle)"
              value={formState?.itemType}
              options={itemTypeOptions}
              disabled={isAddRecipe}
              onFocus={() => setCurrentComponent("add_product_type")}
              onChange={(e, option) => {
                removeErrorStateOnChange("add_product_type");
                handleFormChange("itemType", option);
              }}
              onInputChange={(e) => {
                if (!e) return handleFormChange("itemType", null);
                if (!e.target.value) return handleFormChange("itemType", null);
                removeErrorStateOnChange("add_product_type");
                handleFormChange("itemType", {
                  id: "custom",
                  label: e.target.value?.toUpperCase(),
                });
              }}
              onBlur={(e) => {
                validateForm("add_product_type", formState);
              }}
              getOptionLabel={(option) => {
                return option.label?.toUpperCase();
              }}
              isOptionEqualToValue={(option, value) =>
                value.id === "custom" ? value : option.label === value.label
              }
              markers={JSON.stringify({
                down: "add_product_schedule_type",
                left: "add_product_brand",
                up: "add_product_manufacturer",
                right: "add_product_packaging",
              })}
              error={checkErrorStateExists("add_product_type", errorState)}
              required
              freeSolo
            />
          </Grid>
          <Grid item xs={1.2}>
            <TextInput
              id="add_product_packaging"
              value={formState?.medicinePackaging}
              name="medicinePackaging"
              label="Pack(1kg, 1ltr, 10Tab)"
              onFocus={() => setCurrentComponent("add_product_packaging")}
              onChange={(e) => {
                removeErrorStateOnChange("add_product_packaging");
                handleFormChange("medicinePackaging", e.target.value);
              }}
              onBlur={(e) => {
                validateForm("add_product_packaging", formState);
              }}
              inputProps={{
                "data-markers": JSON.stringify({
                  down: "add_product_hsn_code",
                  left: "add_product_type",
                  right: "add_product_qty_per_unit",
                  up: "add_product_manufacturer",
                }),
              }}
              error={checkErrorStateExists("add_product_packaging", errorState)}
              required
            />
          </Grid>
          <Grid item xs={1.2}>
            <NumberInput
              id="add_product_qty_per_unit"
              name="divisor"
              label="Units/Pack(1000,10,etc)"
              value={formState?.divisor}
              onBlur={(e) => {
                validateForm("add_product_qty_per_unit", formState);
              }}
              onFocus={() => setCurrentComponent("add_product_qty_per_unit")}
              onValueChange={(values) => {
                removeErrorStateOnChange("add_product_qty_per_unit");
              }}
              onChange={(e) => {
                handleFormChange("divisor", +e.target.value);
              }}
              disabled={isAddRecipe}
              decimalScale={0}
              allowNegative={false}
              inputProps={{
                "data-markers": JSON.stringify({
                  up: "add_product_marketer",
                  down: "add_product_rack",
                  left: "add_product_packaging",
                  right: "add_product_outer_qty",
                }),
              }}
              error={checkErrorStateExists(
                "add_product_qty_per_unit",
                errorState
              )}
              required
            />
          </Grid>
          {/* <Grid item xs={1}>
            <TextInput
              id="add_product_divisor_unit"
              value={formState?.divisorUnit}
              name="medicineDivisorUnit"
              label="Unit Measure(gm, ml, pcs)"
              disabled={isAddRecipe}
              onFocus={() => setCurrentComponent("add_product_divisor_unit")}
              onChange={(e) => {
                removeErrorStateOnChange("add_product_divisor_unit");
                handleFormChange("divisorUnit", e.target.value);
              }}
              onBlur={(e) => {
                validateForm("add_product_divisor_unit", formState);
              }}
              inputProps={{
                "data-markers": JSON.stringify({
                  down: "add_product_rack",
                  left: "add_product_qty_per_unit",
                  right: "add_product_outer_qty",
                  up: "add_product_manufacturer",
                }),
              }}
              error={checkErrorStateExists(
                "add_product_divisor_unit",
                errorState
              )}
              required
            />
          </Grid> */}
          <Grid item xs={1.2}>
            <NumberInput
              id="add_product_outer_qty"
              label="Outer Qty/Pk"
              name="outerQty"
              value={formState?.outerQtyPack}
              onFocus={() => setCurrentComponent("add_product_outer_qty")}
              onChange={(e) => {
                handleFormChange("outerQtyPack", +e.target.value);
              }}
              inputProps={{
                "data-markers": JSON.stringify({
                  up: "add_product_short_code",
                  down: "add_product_rack1",
                  left: "add_product_qty_per_unit",
                  right: "add_product_gst",
                }),
              }}
            />
          </Grid>
          <Grid item xs={1.2}>
            <SelectInput
              id="add_product_gst"
              name="medicineGstPer"
              value={formState?.gst}
              label="GST"
              onFocus={() => setCurrentComponent("add_product_gst")}
              isOptionEqualToValue={(option, value) => {
                return option.label === value.label;
              }}
              onBlur={(e) => {
                validateForm("add_product_gst", formState);
              }}
              onChange={(event, option) => {
                removeErrorStateOnChange("add_product_gst");
                handleFormChange("gst", option);
              }}
              getOptionLabel={(option) => {
                return option.label;
              }}
              options={gstValues}
              markers={JSON.stringify({
                up: "add_product_brand",
                down: "add_product_barcode",
                left: "add_product_outer_qty",
                right: "add_product_schedule_type",
              })}
              error={checkErrorStateExists("add_product_gst", errorState)}
              required
            />
          </Grid>
          <Grid item xs={1.2}>
            <SelectInput
              id="add_product_schedule_type"
              name="scheduledId"
              value={formState?.scheduleType}
              label="Schedule Type"
              onFocus={() => setCurrentComponent("add_product_schedule_type")}
              onBlur={(e) => {
                validateForm("add_product_schedule_type", formState);
              }}
              onChange={(event, option) => {
                removeErrorStateOnChange("add_product_schedule_type");
                handleFormChange("scheduleType", option);
              }}
              disabled={isAddRecipe}
              options={medicineScheduleTypes}
              getOptionLabel={(option) => option.label}
              isOptionEqualToValue={(option, value) => {
                return option.label === value.label;
              }}
              markers={JSON.stringify({
                up: "add_product_type",
                down: "add_product_therapeutic",
                left: "add_product_gst",
                right: "add_product_hsn_code",
              })}
              error={checkErrorStateExists(
                "add_product_schedule_type",
                errorState
              )}
              required
            />
          </Grid>
          <Grid item xs={1.2}>
            <SelectInput
              id="add_product_hsn_code"
              name="hsnCode"
              value={formState?.hsnCode || ""}
              label="HSN Code"
              inputRef={hsnCodeRef}
              disableClearable={false}
              noOptionsText={"Search HSN code"}
              onFocus={() => setCurrentComponent("add_product_hsn_code")}
              onBlur={() => validateForm("add_product_hsn_code", formState)}
              onInputChange={(e, newValue) => {
                if (!newValue) return;
                if (isNaN(newValue)) {
                  return;
                }
                removeErrorStateOnChange("add_product_hsn_code");
                handleFormChange("hsnCode", newValue);
                if (newValue.length >= 3) {
                  searchHsn(`search=${newValue.trim()}`).then((resp) => {
                    const updatedResp = resp
                      .filter((prod) => prod?.hsnCodeId && prod?.hsnCode)
                      .map((prod) => ({
                        id: prod.hsnCodeId,
                        label: prod.hsnCode,
                      }));
                    setHsnOptions(updatedResp);
                  });
                } else {
                  setHsnOptions([]);
                }
              }}
              onChange={(event, option) => {
                if (option) {
                  const selectedValue = option.label;
                  handleFormChange("hsnCode", selectedValue);
                } else {
                  handleFormChange("hsnCode", "");
                }
              }}
              options={hsnOptions}
              getOptionLabel={(option) => {
                if (!option) return "";
                return option.label || option;
              }}
              isOptionEqualToValue={(option, value) => option === value}
              markers={JSON.stringify({
                up: "add_product_packaging",
                down: "add_product_sub_therapeutic",
                left: "add_product_schedule_type",
                right: "add_product_rack",
              })}
              error={checkErrorStateExists("add_product_hsn_code", errorState)}
              required
            />
          </Grid>
          <Grid item xs={1.2}>
            <TextInput
              id="add_product_rack"
              name="rack"
              label="Rack1"
              value={formState?.rack}
              onFocus={() => setCurrentComponent("add_product_rack")}
              onChange={(e) => {
                handleFormChange("rack", e.target.value.toUpperCase());
              }}
              maxInputLength={2000}
              inputProps={{
                "data-markers": JSON.stringify({
                  up: "add_product_qty_per_unit",
                  down: "add_substitute",
                  left: "add_product_hsn_code",
                  right: "add_product_rack1",
                }),
              }}
            />
          </Grid>
          <Grid item xs={1.2}>
            <TextInput
              id="add_product_rack1"
              name="rack1"
              label="Rack2"
              value={formState?.rack1}
              onFocus={() => setCurrentComponent("add_product_rack1")}
              onChange={(e) => {
                handleFormChange("rack1", e.target.value.toUpperCase());
              }}
              inputProps={{
                "data-markers": JSON.stringify({
                  up: "add_product_outer_qty",
                  down: "add_product_isLoose",
                  left: "add_product_rack",
                  right: "add_product_barcode",
                }),
              }}
            />
          </Grid>
          <Grid item xs={1.2}>
            <TextInput
              id="add_product_barcode"
              value={formState?.barcode}
              name="barcode"
              label="EAN/Barcode"
              onFocus={() => setCurrentComponent("add_product_barcode")}
              onChange={(e) => {
                handleFormChange("barcode", e.target.value);
              }}
              maxInputLength={10000}
              inputProps={{
                "data-markers": JSON.stringify({
                  up: "add_product_gst",
                  down: "add_product_isLoose",
                  left: "add_product_rack1",
                  right: "add_product_therapeutic",
                }),
              }}
            />
          </Grid>
          <Grid item xs={1.2}>
            <SelectInput
              id="add_product_therapeutic"
              name="therapeutic"
              label="Therapeutic"
              value={formState?.therapeutic}
              onFocus={() => setCurrentComponent("add_product_therapeutic")}
              onChange={(event, option) => {
                handleFormChange("therapeutic", option);
              }}
              onInputChange={(e) => {
                if (!e) return handleFormChange("therapeutic", null);
                if (!e.target.value)
                  return handleFormChange("therapeutic", null);
                handleFormChange("therapeutic", {
                  id: "custom",
                  label: e.target.value,
                });
              }}
              options={therapeuticTypes}
              getOptionLabel={(option) => option.label}
              isOptionEqualToValue={(option, value) =>
                value.id === "custom" ? value : option.label === value.label
              }
              maxInputLength={1000}
              markers={JSON.stringify({
                down: "add_product_compounds",
                left: "add_product_barcode",
                right: "add_product_sub_therapeutic",
                up: "add_product_schedule_type",
              })}
              freeSolo
            />
          </Grid>
          <Grid item xs={1.2}>
            <TextInput
              id="add_product_sub_therapeutic"
              value={formState?.subTherapeutic}
              name="subtherapeutic"
              label="Sub-Therapeutic"
              onFocus={() => setCurrentComponent("add_product_sub_therapeutic")}
              onChange={(e) => {
                handleFormChange("subTherapeutic", e.target.value);
              }}
              maxInputLength={1000}
              inputProps={{
                "data-markers": JSON.stringify({
                  up: "add_product_hsn_code",
                  down: "add_product_compounds",
                  left: "add_product_therapeutic",
                  right: "add_substitute",
                }),
              }}
            />
          </Grid>
          <Grid item xs={1.2}>
            <SelectInput
              label="Substitute for"
              id="add_substitute"
              disableClearable={false}
              onFocus={() => {
                setCurrentComponent("add_substitute");
              }}
              onChange={substituteChangeHandler}
              getOptionLabel={(option) => option.label}
              isOptionEqualToValue={(option, value) => {
                return option?.label === value.label;
              }}
              value={formState?.substitute}
              renderOption={(props, option) => {
                return (
                  <li {...props} key={option.id}>
                    {option.label}
                  </li>
                );
              }}
              onInputChange={(e, value) => {
                if (value?.length > 2) {
                  debounceSearchMedicine(value);
                }
                if (value?.length < 1) {
                  setIsGenericDosageReadOnly(false);
                  const payload = {
                    ...formState,
                    genericDosage: [],
                    substitute: null,
                  };
                  dispatchFormState(payload);
                }
              }}
              options={medicineOptions}
              markers={JSON.stringify({
                up: "add_product_rack",
                down: "add_product_compounds",
                left: "add_product_sub_therapeutic",
                right: "add_product_isLoose",
              })}
            />
          </Grid>
          <Grid
            container
            spacing={2}
            sx={{
              padding: "0.8rem 0.5rem 0.5rem 1rem",
              width: "100%",
            }}
          >
            <Grid item xs={1.2}>
              <Checkbox
                id="add_product_isLoose"
                name="isLoose"
                label="Is Loose"
                checked={isLoose}
                onFocus={() => setCurrentComponent("add_product_isLoose")}
                onChange={(e) => {
                  handleFormChange("isLoose", e.target.checked);
                }}
                inputProps={{
                  "data-markers": JSON.stringify({
                    down: "add_product_compounds",
                    left: "add_substitute",
                    up: "add_product_rack1",
                    right: "add_product_is_chronic",
                  }),
                }}
              />
            </Grid>
            <Grid item xs={1.2}>
              <Checkbox
                id="add_product_is_chronic"
                name="chronic"
                label="Chronic"
                checked={isChronic}
                onChange={(e) => {
                  handleFormChange("isChronic", e.target.checked);
                }}
                onFocus={() => setCurrentComponent("add_product_is_chronic")}
                inputProps={{
                  "data-markers": JSON.stringify({
                    down: "add_product_compounds",
                    left: "add_product_isLoose",
                    up: "add_product_rack1",
                    right: "add_product_tb",
                  }),
                }}
              />
            </Grid>

            <Grid item xs={1.2}>
              <Checkbox
                id="add_product_tb"
                name="chronic"
                label="Is TB"
                checked={isTb}
                onChange={(e) => {
                  handleFormChange("isTb", e.target.checked);
                }}
                onFocus={() => setCurrentComponent("add_product_tb")}
                inputProps={{
                  "data-markers": JSON.stringify({
                    down: "add_product_compounds",
                    left: "add_product_is_chronic",
                    up: "add_product_barcode",
                    right: "add_product_compounds",
                  }),
                }}
              />
            </Grid>
          </Grid>

          {!isAddRecipe && (
            <Grid item xs={6}>
              <ChipInputSelect
                id="add_product_compounds"
                name="genericDosage"
                label="Salts(compounds)"
                value={formState?.genericDosage}
                onFocus={() => setCurrentComponent("add_product_compounds")}
                options={compoundOptions}
                getOptionLabel={(option) => {
                  return option;
                }}
                onInputChange={compoundInputChangeHandler}
                onChange={(e, value) => {
                  handleFormChange("genericDosage", value);
                }}
                disableCloseOnSelect={true}
                blurOnSelect={false}
                markers={JSON.stringify({
                  up: "add_product_isLoose",
                  down: "add_product_description",
                  left: "add_product_tb",
                  right: "add_product_description",
                })}
                readOnly={isGenericDosageReadOnly}
                isOptionEqualToValue={(option, value) => {
                  return option === value;
                }}
              />
            </Grid>
          )}
          <Grid item xs={12}>
            <TextInput
              id="add_product_description"
              name="addProductRemarks"
              label="Content"
              onChange={(e) => {
                handleFormChange("description", e.target.value);
              }}
              value={formState?.description}
              onFocus={() => {
                setCurrentComponent("add_product_description");
              }}
              maxInputLength={2000}
              inputProps={{
                "data-markers": JSON.stringify({
                  up: "add_product_compounds",
                  down: "add_product_description",
                  left: "add_product_compounds",
                  right: "add_product_name",
                }),
              }}
            />
          </Grid>
        </Grid>
      )}
    </>
  );
};

export default GeneralTab;
